import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import PaginatedDataGrid from "components/PaginatedDataGrid";
import BasicLayout from "components/Layouts/BasicLayout";
import stripeService from "services/stripe";
import { formatCurrency, formatDate } from "utils/commonFunctions";
import { IService } from "types/App";

const Charges: React.FC = () => {
  const columns: GridColDef[] = [
    {
      field: "billing_details",
      headerName: "Customer",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => `${params.value.email} - ${params.value.name}`
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => formatCurrency(params.value, params.row.currency)
    },
    {
      field: "created",
      headerName: "Date",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => formatDate(new Date(params.value * 1000))
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${params.row.refunded
            ? 'bg-red-100 text-red-800'
            : params.value === 'succeeded'
              ? 'bg-green-100 text-green-800'
              : params.value === 'pending'
                ? 'bg-yellow-100 text-yellow-800'
                : 'bg-red-100 text-red-800'
          }`}>
          {params.row.refunded ? 'Refunded' : params.value.charAt(0).toUpperCase() + params.value.slice(1)}
        </div>
      )
    },
  ];

  return (
    <BasicLayout>
      <Grid container spacing={4}>
        <Grid item xs={6} display={"flex"} alignItems={"center"}>
          <Typography variant="h4">Charges</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <PaginatedDataGrid
              columns={columns}
              collectionName="charges"
              defaultSortField="created"
              defaultSortDirection="desc"
              service={stripeService as IService}
              fetchFnc="fetchCharges"
              createFnc="createCharge"
              updateFnc="updateCharge"
              removeFnc="removeCharge"
              filterOptions={[
                {
                  label: "Status",
                  name: "status",
                  type: "select",
                  operator: "eq",
                  options: [
                    { label: "Succeeded", value: "succeeded" },
                    { label: "Failed", value: "failed" },
                    { label: "Pending", value: "pending" }
                  ]
                },
                {
                  label: "Description",
                  name: "description",
                  type: "text",
                  operator: "search",
                },
              ]}
            />
          </Box>
        </Grid>
      </Grid>
    </BasicLayout>
  );
};

export default Charges; 